import React from 'react';
import styled from 'styled-components';
import qs from 'query-string';
import * as jwt from 'rev.sdk.js/Utils/jwt';
import {getOutlet, useOutlet} from 'reconnect.js';
import * as JStorage from '../../JStorage';
import * as NavUtil from '../../Utils/NavUtil';

export default function AppLayout(props) {
  const {access_token} = qs.parse(props.location.search) || {};
  // const skipLogin = true; // TODO: for test, remove it
  const skipLogin = ['/app/member/register', '/app/proxy'].includes(
    NavUtil.sliceTailSlash(props.location.pathname),
  );
  const [user, setUser] = useOutlet('user');

  const [loading, setLoading] = React.useState(skipLogin ? false : true);

  React.useEffect(() => {
    // mimic login
    (async () => {
      if (access_token && !skipLogin) {
        setLoading(true);
        try {
          const decoded = await jwt.decodeToken(access_token);

          const profile = await JStorage.fetchOneDocument(
            'user_profile',
            {
              owner: decoded.sub,
            },
            null,
            {token: access_token},
          );

          setUser({
            username: decoded.sub,
            token: access_token,
            ...decoded,
            data: {...profile},
          });
        } catch (e) {
          console.warn('app page login error', e);
        }
      }
      setLoading(false);
    })();
  }, [access_token, skipLogin]);

  return (
    <Wrapper>
      <div className="main">
        <div className="content">
          {loading ? (
            <h2>用戶資料準備中...</h2>
          ) : !skipLogin && !user ? (
            <h2>發生錯誤，無法讀取使用者資料</h2>
          ) : (
            props.children
          )}
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  --contentMinHeight: 100vh;
  --primaryColor: #2470ac;
  --primaryLightColor: #f0f4f8;
  --thirdThBorderColor: #e0e0e0;
  --primaryThBorderColor: #e0e0e0;
  --primaryBgcolor: #ebf0f2;
  --text-color: #222222;
  --disabledBg: #d9d9d9;
  --background: #fcfafc;
  --ant-primary-color: var(--primaryColor);
  --ant-primary-5: var(--primaryColor);

  min-height: var(--contentMinHeight);
  font-weight: '500';
  color: var(--text-color);
  background-color: var(--background);
  /* body background set on useEffect above */

  /* overwrite ant css */
  .ant-form-item-label > label {
    color: var(--text-color);
  }
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-input-number-affix-wrapper,
  .ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-picker,
  .rev-input {
    border-radius: 8px;
    border-color: var(--thirdThBorderColor);
    padding: 8px 11px;
    line-height: 30px;
  }

  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: auto; /* overwrite fixed height */
    min-height: 32px;
  }

  .ant-col-24.ant-form-item-label {
    padding: 0;
  }
  .ant-table-footer {
    background-color: white;
  }

  & .form-error-list {
    padding: 0 20px;
    color: var(--primaryColor);
    font-weight: 600;
    font-size: 12px;
  }
  & .tda-form-button {
    flex: 1;
  }
  & .tda-event-reg-form {
  }

  & > .main {
    max-width: var(--contentMaxWidth);
    display: flex;
    align-items: flex-start;
    // gap: 20px;

    & > .content {
      flex: 1;
      min-height: 300px;
      padding: 20px;
    }
  }

  @media only screen and (max-width: 768px) {
    & > .main {
      flex-direction: column;
      align-items: stretch;
    }
  }
`;
